/**
 =========================================================
 * Material Dashboard 2 React - v2.2.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2023 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import * as React from 'react';

// @mui material components
import Grid from "@mui/material/Grid";
import {isEmpty} from "../../../components/Utils/common";
import MDInput from "../../../components/MDInput";
import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";


function MerchantBankDetails({merchant, editmode, setMerchant, type}) {
  const { register, formState: { errors } } = useFormContext();
  return (
      <Grid mt={3} mb={3} padding={2} bgColor="white">
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={3}>
            <MDInput
              type="text"
              label="Statement Frequency"
              name="merchantFrequency"
              {...register("merchantFrequency")}
              fullWidth
              disabled={!editmode}
              error={errors?.merchantFrequency}
              helperText={errors.merchantFrequency ? errors.merchantFrequency.message : ''}
            />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Settlement Bank Name" name="bankName"
                     {...register("bankName")}
                     fullWidth  d
                     disabled={!editmode}
                     error={errors?.bankName}
                     helperText={errors.bankName ? errors.bankName.message : ''}
            />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Settlement Account Name" name="accountName"
                     {...register("accountName")}
                     fullWidth
                     disabled={!editmode}
                     error={errors?.bankerBranchName}
                     helperText={errors.bankerBranchName ? errors.bankerBranchName.message : ''}
            />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Settlement Account Number" name="accountNo"
                     {...register("accountNo")}
                     fullWidth
                     disabled={!editmode}
                     error={errors?.accountNo}
                     helperText={errors.accountNo ? errors.accountNo.message : ''}
            />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Settlement Bank Code (BSB)" name="bsbNumber"
                     {...register("bsbNumber")}
                     fullWidth
                     disabled={!editmode}
                     error={errors?.ifscCode}
                     helperText={errors.ifscCode ? errors.ifscCode.message : ''}
            />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Expected Card Business per Month" name="expectedCardBusinessPerMonth"
                     {...register("expectedCardBusinessPerMonth")}
                     fullWidth
                     disabled={!editmode}
                     error={errors?.expectedCardBusinessPerMonth}
                     helperText={errors.expectedCardBusinessPerMonth ? errors.expectedCardBusinessPerMonth.message : ''}
            />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Average Bill Amount" name="averageBillAmount"
                     {...register("averageBillAmount")}
                     fullWidth
                     disabled={!editmode}
                     error={errors?.averageBillAmount}
                     helperText={errors.averageBillAmount ? errors.averageBillAmount.message : ''}
            />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Turnover Years 1" name="turnoverYear1"
                     {...register("turnoverYear1")}
                     fullWidth
                     disabled={!editmode}
                     error={errors?.turnoverYear1}
                     helperText={errors.turnoverYear1 ? errors.turnoverYear1.message : ''}
            />
          </Grid>
        </Grid>
      </Grid>
  );
}

MerchantBankDetails.defaultProps = {
  merchant: false,
  editmode: false,
  setMerchant: false,
  type: 'updated'
}

MerchantBankDetails.propTypes = {
  merchant: PropTypes.any,
  editmode: PropTypes.bool,
  setMerchant: PropTypes.func,
  type: PropTypes.string
}

export default MerchantBankDetails;
